import { render, staticRenderFns } from "./StockTrfPrintDetails.vue?vue&type=template&id=5c3bd004&"
import script from "./StockTrfPrintDetails.vue?vue&type=script&lang=js&"
export * from "./StockTrfPrintDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports